import * as moment from 'moment';

export class LastLineupMatch {
    awayTeamId: number;
    awayTeamName: string;
    awayTeamScore: number;
    matchDate: moment.Moment;
    homeTeamId: number;
    homeTeamName: string;
    homeTeamScore: number;
}



// WEBPACK FOOTER //
// /Users/mac/PlayGround/src/app/shared/last-lineup-match.model.ts